const STORAGE_PREFIX = 'sigma:table-columns:'

const cloneColumns = (columns = []) => columns.map(column => ({ ...column }))

const normalizeStoredColumns = (storedColumns = [], defaultColumns = []) => {
  const defaultMap = new Map(defaultColumns.map(column => [column.key, column]))
  const normalized = []

  storedColumns.forEach((storedColumn) => {
    const defaultColumn = defaultMap.get(storedColumn.key)
    if (!defaultColumn) {
      return
    }
    normalized.push({
      ...defaultColumn,
      visible: storedColumn.visible !== false,
    })
    defaultMap.delete(storedColumn.key)
  })

  defaultColumns.forEach((column) => {
    if (defaultMap.has(column.key)) {
      normalized.push({ ...column })
    }
  })

  return normalized
}

export const getStoredColumns = (tableKey, defaultColumns = []) => {
  if (!tableKey) {
    return cloneColumns(defaultColumns)
  }
  try {
    const rawValue = window.localStorage.getItem(`${STORAGE_PREFIX}${tableKey}`)
    if (!rawValue) {
      return cloneColumns(defaultColumns)
    }
    const storedColumns = JSON.parse(rawValue)
    if (!Array.isArray(storedColumns)) {
      return cloneColumns(defaultColumns)
    }
    return normalizeStoredColumns(storedColumns, defaultColumns)
  } catch (error) {
    return cloneColumns(defaultColumns)
  }
}

export const saveStoredColumns = (tableKey, columns = []) => {
  if (!tableKey) {
    return
  }
  const payload = columns.map(column => ({
    key: column.key,
    visible: column.visible !== false,
  }))
  window.localStorage.setItem(`${STORAGE_PREFIX}${tableKey}`, JSON.stringify(payload))
}

export const getVisibleColumns = (columns = []) => columns.filter(column => column.visible !== false)
